import React, { useEffect, useState } from "react";
import SuperUserHeader from "../../components/SuperUserHeader";
import SuperUserSideMenu from "../../components/SuperUserSideMenu";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { formatName, formatIdWithLength } from "../../utils/format";
import {
    setSuccess,
    setError,
    getSuperUserDetail,
} from "../../reducers/superUser";
import ReturnButton from "../../components/ReturnButton";
import NotFoundPage from "../../pages/NotFoundPage";

const UserDetail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        loading,
        success,
        error,
        actionName,
        actionStatus,
        detailData,
    } = useSelector((state: any) => state.superUser);
    const { id } = useParams<{ id: string }>();
        
    useEffect(() => {
        if(id){
            const data = {
                id: Number(id),
            }
            dispatch(getSuperUserDetail(data));
        }
    }, [id]);

    const userName = formatName(detailData.first_name, detailData.last_name);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        if(error) {
            enqueueSnackbar("I love snacks.", {
                content: (key) => (
                <CustomToast
                    title={"メッセージ"}
                    message={error}
                    variant={"error"}
                    snackbarKey={key}
                    closeSnackbar={closeSnackbar}
                />
                ),
            });
            dispatch(setError(null));
        }
        else if(success) {
            enqueueSnackbar("I love snacks.", {
                content: (key) => (
                <CustomToast
                    title={"メッセージ"}
                    message={success}
                    variant={"success"}
                    snackbarKey={key}
                    closeSnackbar={closeSnackbar}
                />
                ),
            });
            dispatch(setSuccess(null));
        }
    }, [error, success, actionName]);

    if (!detailData || (Array.isArray(detailData) && detailData.length === 0) || Object.keys(detailData).length === 0) {
        if(actionName == "getSuperUserDetail" && actionStatus == "rejected") return <NotFoundPage />;
        return ;
    }

    return (
        <div className="bg-alu-base h-dvh">
        <SuperUserHeader />
        <div className="mt-6 px-6 flex gap-6 relative">
            <SuperUserSideMenu />
            <div className="flex-1">
            <div className="mb-6 flex items-center gap-4">
                <ReturnButton onClick={() => navigate(-1)} />
                <span className="text-sm alu-text-base-1">/</span>
                <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
                    {userName + " の詳細"}
                </h3>
            </div>

            <div className="mb-2">
                <CustomButton
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => navigate("/control/user/edit/" + detailData.id)}
                    customStyle="!min-w-[63px]"
                >
                    編集
                </CustomButton>
            </div>
            <div className="bg-white rounded-lg p-4">
                <form className="w-full">
                    <div className="w-[50%] max-w-[464px]">
                        <div className="grid grid-cols-[112px_1fr] items-center gap-4 mb-4 py-[0.3125rem]">
                            <p className="text-sm font-bold leading-[1.3125] alu-text-base-2">ID</p>
                            <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">{formatIdWithLength(detailData.id)}</p>
                        </div>
                        <div className="grid grid-cols-[112px_1fr] items-center gap-4 mb-4 py-[0.3125rem]">
                            <p className="text-sm font-bold leading-[1.3125] alu-text-base-2">名前</p>
                            <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">{formatName(detailData.first_name, detailData.last_name)}</p>
                        </div>
                        <div className="grid grid-cols-[112px_1fr] items-center gap-4 mb-4 py-[0.3125rem]">
                            <p className="text-sm font-bold leading-[1.3125] alu-text-base-2">メールアドレス</p>
                            <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">{detailData.email}</p>
                        </div>
                        <div className="mb-4 whitespace-pre-wrap">
                            <p className="text-sm font-bold leading-[1.3125] alu-text-base-2 mb-2">備考</p>
                            <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">{detailData.note}</p>
                        </div>
                    </div>
                </form>
            </div>
            </div>
        </div>
        </div>
    );
};

export default UserDetail;
